import styled, { css } from "styled-components";

export const DeleteFeedEntityContainer = styled.div`
  position: relative;
`;

interface IConfirmDeleteContainerProps {
  showConfirmModal: boolean;
}

export const ConfirmDeleteContainer = styled.div<IConfirmDeleteContainerProps>`
  position: absolute;
  right: 0;
  top: 25px;
  padding: 0.5rem;
  border-radius: 4px;
  background-color: ${({ theme }) =>
    theme.mode === "dark" ? "#101010" : "#FFFFFF"} !important;
  gap: 0.5rem;
  display: flex;
  white-space: nowrap;
  flex-direction: column;

  color: ${({ theme }) => theme.feed.usernameColor};
  border: 1px solid
    ${({ theme }) => (theme.mode === "dark" ? "#FFFFFF29" : "#05050529")};

  transition: 0.3s all;

  opacity: 0;
  pointer-events: none;

  button {
    text-align: center !important;

    :disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }

  ${({ showConfirmModal }) =>
    showConfirmModal &&
    css`
      opacity: 1;
      pointer-events: all;
    `}
`;
